import type { AxiosInstance } from 'axios';

/** A purchased EasyPost shipping label, mirrored from `ShippingLabelEntity`. */
export interface ShippingLabel {
  id: string;
  orderId: string;
  carrier: string;
  service: string;
  trackingCode: string | null;
  labelUrl: string | null;
  cost: string;
  currency: string;
}

interface PurchaseLabelRequest {
  orderId: string;
  shipmentId: string;
  rateId: string;
}

export function createShippingService(client: AxiosInstance) {
  return {
    async purchaseLabel(input: PurchaseLabelRequest): Promise<ShippingLabel> {
      const { data } = await client.post<ShippingLabel>('/shipping/labels', input);
      return data;
    },

    async getLabel(orderId: string): Promise<ShippingLabel> {
      const { data } = await client.get<ShippingLabel>(`/shipping/labels/${orderId}`);
      return data;
    },

    async downloadLabel(orderId: string): Promise<Blob> {
      const { data } = await client.get<Blob>(`/shipping/labels/${orderId}/download`, {
        responseType: 'blob',
      });
      return data;
    },
  };
}

export type ShippingService = ReturnType<typeof createShippingService>;
